module.exports = __webpack_public_path__ + "static/media/xray-training-lateral-nonflex3.48fe78d0.png";